/* =========================================================
   EAZY CLOTHES — WYSZUKIWARKA PELNOEKRANOWA

   Przejmuje przycisk lupy Savora i otwiera wlasny panel. Panelu Savora
   NIE usuwamy: bez JS dziala dalej stary, wiec to ulepszenie, a nie
   zastapienie.

   Zrodlo danych to /search/suggest.json — ten sam predictive search
   Shopify, ktory zasila panel Savora, tylko w JSON zamiast HTML sekcji.
   Zadnego nowego mechanizmu pobierania.

   Nosnikiem jest natywny <dialog> otwierany przez showModal(). Stad za
   darmo: pulapka fokusu, Escape, inert na reszcie strony. Wlasna
   pulapka fokusu bylaby gorsza od tej z przegladarki.
   ========================================================= */
(function ezSearch() {
  const panel = document.querySelector('[data-ez-search]');
  if (!panel) return;

  /* DWA TRYBY.
     'modal'  — <dialog> wywolywany lupa; otwieranie, zamykanie, pulapka
                fokusu i dopasowanie do klawiatury maja sens tylko tutaj.
     'strona' — <div> wbudowany w /search; nie ma czego otwierac ani
                zamykac, wiec cala ta maszyneria jest pomijana.
     Sekcja pilnuje, zeby na danej stronie istniala tylko jedna
     instancja, wiec querySelector nie ma jak trafic w niewlasciwa. */
  const trybStrony = panel.dataset.ezSearchTryb === 'strona';
  if (!trybStrony && typeof panel.showModal !== 'function') return;

  const input = panel.querySelector('[data-ez-search-input]');
  const grid = panel.querySelector('[data-ez-search-grid]');
  const label = panel.querySelector('[data-ez-search-label]');
  const status = panel.querySelector('[data-ez-search-status]');
  const scroller = panel.querySelector('[data-ez-search-scroll]');
  const wzorzec = panel.querySelector('[data-ez-search-card]');
  if (!input || !grid || !status || !wzorzec) return;

  const TRIGGER = 'button.search-modal__button';
  const DEBOUNCE = 180;
  const MIN_ZNAKOW = 2;
  const LIMIT = 10;
  /* Ogloszenie dla czytnika ekranu czeka dluzej niz samo zapytanie.
     Przy szybkim pisaniu ma padac jedno, na koncu — nie po jednym
     na kazda litere. */
  const OGLOSZENIE_PO = 700;

  const prefiksy = (panel.dataset.brandPrefixes || '')
    .split('||')
    .map((s) => s.trim())
    .filter(Boolean);

  /* Stan pusty jest naprawde pusty: ani etykiety, ani kafli. Powrot
     do niego (skasowana fraza) czysci jedno i drugie. */
  const etykietaPusta = '';

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cache = new Map();
  let kontroler = null;
  let timerSzukania = 0;
  let timerOgloszenia = 0;
  let wyzwalacz = null;

  /* --- narzedzia --- */

  const bezPrefiksu = (tytul) => {
    const t = String(tytul).trim();
    const p = prefiksy.find((x) => t.toLowerCase().startsWith(x.toLowerCase()));
    if (!p) return t;
    const reszta = t.slice(p.length).replace(/^[-–—:\s]+/, '').trim();
    return reszta || t;
  };

  /* Shopify oddaje adres obrazu z ?v=..., wiec szerokosc dokladamy
     przez &. Bez tego siatka ciagnelaby pelne kadry. */
  const obraz = (url, w) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=${w}` : '');

  const cena = (p) => {
    const v = Number(p);
    if (!isFinite(v)) return '';
    return v.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
  };

  /* --- MAPA MYSLI ---
     Produkty rozrzucone w przestrzeni, roznych rozmiarow, bez kart —
     samo wyciete zdjecie i podpis na ciemnym tle.

     ROZMIESZCZENIE. Prawdziwe wykrywanie kolizji (losuj, sprawdz,
     odrzuc, powtorz) zostalo odrzucone: ma nieograniczony czas dzialania
     i przy pechowym ziarnie potrafi sie zapetlic. Zamiast tego kazdy
     wiersz rozdziela swoja szerokosc miedzy wlasne kafle i przerwy
     miedzy nimi, a kafel rusza sie wylacznie w granicach przypisanej mu
     przerwy. Nachodzenie jest wykluczone rachunkiem, nie wykrywaniem.

     Liczba kafli w wierszu wynika z ROZDZIALU ROWNA REKA (patrz
     rozdziel), nie ze stalej liczby kolumn. Bez tego ostatni wiersz
     bywal niepelny i zapelnial sie od lewej, zostawiajac pusta prawa
     strone mapy. Wysokosc wiersza bierze sie z realnej wysokosci
     najwiekszego kafla, a nie ze stalej — inaczej telefon dostawal
     wiersze wysokie na 300px z kaflami po 150px i mapa byla w polowie
     pusta.

     DETERMINIZM. Ziarno to hash frazy, wiec ta sama fraza uklada sie
     zawsze tak samo — takze przy powrocie z cache. Nic nie przeskakuje.

     ROZMIAR NIESIE TRAFNOSC. Pozycje 1-2 dostaja duzy kadr, 3-6 sredni,
     reszta maly. To nie dekoracja.

     DOSTEPNOSC. Pozycjonowanie absolutne NIE zmienia kolejnosci DOM:
     renderujemy w kolejnosci trafnosci z API i tylko nadajemy wspolrzedne.
     Tab i czytnik ekranu ida wiec po trafnosci, niezaleznie od tego,
     gdzie element wypadl na ekranie. To poprawa wzgledem poprzedniego
     ukladu kolumnowego, ktory lamal kolejnosc czytania na kolumnowa. */

  const hash = (s) => {
    let h = 2166136261;
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  };

  /* mulberry32 — maly, szybki generator o powtarzalnej sekwencji. */
  const prng = (seed) => () => {
    seed |= 0;
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };

  const mobile = () => window.matchMedia('(max-width: 819px)').matches;

  const rozmiar = (i) => (i < 2 ? 'l' : i < 6 ? 'm' : 's');

  /* Szerokosci kafli (procent szerokosci mapy) mieszkaja tutaj, a nie
     w arkuszu. Algorytm MUSI je znac, zeby policzyc, ile naprawde
     zostaje wolnego miejsca w wierszu. Dopoki siedzialy wylacznie
     w CSS, kod zakladal luz, ktorego nie bylo: kafel `l` dostawal 26%
     w komorce szerokiej na 25%, wiec deklarowany w komentarzu brak
     nachodzenia byl nieprawda — zmierzone, kafle 0 i 1 zachodzily na
     siebie o 4% szerokosci mapy. */
  const SZER = { l: 28, m: 21, s: 16 };
  const SZER_TEL = { l: 34, m: 28, s: 23 };

  /* Wysokosc podpisu pod kadrem. Stala, bo nazwa jest przycieta do
     dwoch wierszy (line-clamp), a cena to zawsze jeden. */
  const PODPIS = 62;

  /* Rozdzial na wiersze idzie po SZEROKOSCI, nie po liczbie kafli.
     Rowna liczba kafli w wierszu brzmiala sensownie i okazala sie
     zrodlem martwych stref: wiersz z dwoma malymi kaflami zajmowal 32%
     szerokosci, wiec przy dziesieciu wynikach wypelnienie wierszy szlo
     56/63/69/16 procent — srednio okolo polowy mapy bylo pustka.

     Teraz liczba wierszy wynika z sumy szerokosci (tyle, zeby zaden nie
     musial przekroczyc celu), a sam podzial wybiera programowanie
     dynamiczne minimalizujace najszerszy wiersz. Podzial jest CIAGLY,
     wiec kolejnosc kafli w DOM zostaje kolejnoscia trafnosci z API. */
  const ileWierszy = (w, celMax) =>
    Math.max(1, Math.ceil(w.reduce((a, b) => a + b, 0) / celMax));

  const podzial = (w, R) => {
    const n = w.length;
    const pref = [0];
    for (let i = 0; i < n; i++) pref.push(pref[i] + w[i]);
    const best = Array.from({ length: R + 1 }, () => new Array(n + 1).fill(Infinity));
    const skad = Array.from({ length: R + 1 }, () => new Array(n + 1).fill(0));
    best[0][0] = 0;
    for (let r = 1; r <= R; r++) {
      for (let i = r; i <= n; i++) {
        for (let j = r - 1; j < i; j++) {
          const gorszy = Math.max(best[r - 1][j], pref[i] - pref[j]);
          if (gorszy < best[r][i]) {
            best[r][i] = gorszy;
            skad[r][i] = j;
          }
        }
      }
    }
    const ile = [];
    let i = n;
    for (let r = R; r >= 1; r--) {
      const j = skad[r][i];
      ile.unshift(i - j);
      i = j;
    }
    return ile;
  };

  /* Tasowanie Fishera-Yatesa tym samym generatorem — potrzebne do
     rozwarstwienia przesuniec w pionie. */
  const tasuj = (n, los) => {
    const a = Array.from({ length: n }, (_, i) => i);
    for (let i = n - 1; i > 0; i--) {
      const j = Math.floor(los() * (i + 1));
      const t = a[i];
      a[i] = a[j];
      a[j] = t;
    }
    return a;
  };

  /* Kafel powstaje z KLONU wzorca renderowanego przez Liquid
     (snippets/eazy-search-card.liquid, tryb 'szkielet'). Ten sam snippet
     buduje kafle po stronie serwera na /search, wiec markup jest jeden
     i nie ma jak sie rozjechac miedzy skryptem a szablonem.

     Wartosci wchodza przez textContent i wlasciwosci src/href, wiec
     ucieczka znakow nie jest juz potrzebna — przegladarka nie traktuje
     ich jak HTML. Wczesniejsza wersja skladala napis i musiala escapowac
     recznie. */
  /* Kafel powstaje z KLONU wzorca renderowanego przez Liquid
     (snippets/eazy-search-card.liquid, tryb 'szkielet'). Ten sam snippet
     buduje kafle po stronie serwera na /search, wiec markup jest jeden
     i nie ma jak sie rozjechac miedzy skryptem a szablonem.

     Ta funkcja odpowiada WYLACZNIE za tresc kafla. Wspolrzedne, rozmiar
     i parametry unoszenia naklada osobno zastosuj(), bo na /search
     kafle przychodza gotowe z serwera i budowac nie ma czego.

     Wartosci wchodza przez textContent i atrybuty, wiec ucieczka znakow
     nie jest potrzebna — przegladarka nie traktuje ich jak HTML. */
  const kafel = (p) => {
    const el = wzorzec.content.firstElementChild.cloneNode(true);
    el.querySelector('.ez-search__card').setAttribute('href', p.url);
    if (p.image) {
      const img = el.querySelector('img');
      img.setAttribute('src', obraz(p.image, 500));
      img.setAttribute('srcset', `${obraz(p.image, 300)} 300w, ${obraz(p.image, 700)} 700w`);
    }
    el.querySelector('.ez-search__name').textContent = bezPrefiksu(p.title);
    el.querySelector('.ez-search__price').textContent = cena(p.price);
    return el;
  };

  /* GEOMETRIA LICZONA OSOBNO OD MARKUPU.

     Ta funkcja nie dotyka DOM i nie wie, skad wzialy sie kafle: dostaje
     ich liczbe i szerokosc kadru, oddaje wspolrzedne. Rozdzielenie jest
     konieczne, bo na stronie /search kafle przychodza gotowe z serwera
     i trzeba je tylko rozmiescic — nie ma wtedy czego budowac.

     Ziarno to dalej hash frazy, a kolejnosc losowan zostala nietknieta,
     wiec ta sama fraza uklada sie tak samo jak przed rozdzieleniem. */
  const policzUklad = (liczbaKafli, fraza, szerPx) => {
    const los = prng(hash(fraza));
    const telefon = mobile();
    const szer = telefon ? SZER_TEL : SZER;
    const odstep = telefon ? 12 : 20;
    /* celMax decyduje, ile wierszy powstanie; celDoc to gestosc, do
       ktorej kazdy wiersz jest dociagany. */
    const celMax = telefon ? 76 : 78;
    const celDoc = telefon ? 70 : 72;

    const bazowe = Array.from({ length: liczbaKafli }, (_, k) => szer[rozmiar(k)]);
    const rzedy = podzial(bazowe, ileWierszy(bazowe, celMax));

    const pozycje = [];
    let i = 0;
    let y = 0;

    rzedy.forEach((ile) => {
      const w = bazowe.slice(i, i + ile);
      const suma = w.reduce((a, b) => a + b, 0);
      /* Delikatne wyrownanie gestosci: wiersz, ktoremu daleko do celu,
         dostaje kafle nieco wieksze, a przepelniony nieco mniejsze.
         Zakres jest waski, zeby maly kafel nie przerosl duzego
         i rozmiar dalej niosl trafnosc. */
      const skala = Math.min(1.2, Math.max(0.9, celDoc / suma));
      /* Gorny limit na kafel. Bez niego wiersz o dwoch duzych kaflach
         (osiem wynikow: 2+3+3) dociagal je do 33.6% szerokosci, czyli
         435px zdjecia w oknie wyszukiwarki — za duzo, i wiersz robil
         sie nienaturalnie wysoki. */
      const maks = telefon ? 36 : 30;
      let szerokosci = w.map((s) => Math.min(s * skala, maks));
      const sumaS = szerokosci.reduce((a, b) => a + b, 0);
      /* Bezpiecznik: wiersz zawsze zostawia troche miejsca na przerwy. */
      if (sumaS > 96) szerokosci = szerokosci.map((s) => (s * 96) / sumaS);
      const wolne = 100 - szerokosci.reduce((a, b) => a + b, 0);

      /* Przerwy skrajne sa WEZSZE od wewnetrznych. Przy rownych
         przerwach wiersz o dwoch kaflach zostawial po 22% pustki
         z kazdej strony — to bylo widac jako martwa strefa przy
         krawedziach. */
      const jedn = wolne / (ile - 1 + 2 * 0.45);
      const brzeg = jedn * 0.45;
      const maxDx = jedn * 0.35;

      /* Przesuniecia poziome sa centrowane: od kazdego odejmujemy
         srednia wiersza, wiec pojedynczy kafel drga, ale wiersz jako
         calosc nie odplywa w bok. Bez tego niezalezne losowania co
         jakis czas spychaly wszystkie kafle w te sama strone — to jest
         zgloszone "skupianie sie po jednej stronie". */
      const surowe = szerokosci.map(() => (los() - 0.5) * 2 * maxDx);
      const srednia = surowe.reduce((a, b) => a + b, 0) / ile;
      const dx = surowe.map((v) => Math.max(-maxDx, Math.min(maxDx, v - srednia)));

      const wysokosci = szerokosci.map((s) => (s / 100) * szerPx + PODPIS);
      const najwyzszy = Math.max.apply(null, wysokosci);
      /* Swoboda w pionie jest wydzielona z gory: kafel schodzi w dol
         o 0..luzY, a wiersz ma na to wlasny zapas. Dzieki temu rozrzut
         nie potrzebuje ujemnego offsetu i zaden kafel nie wchodzi
         w wiersz sasiada. */
      const luzY = najwyzszy * 0.22;
      /* Przesuniecia pionowe sa ROZWARSTWIONE: kazdy kafel dostaje
         wlasny pas luzu, w losowej kolejnosci. Niezalezne losowania
         raz ustawialy caly wiersz w rowna linie (wyglad sztywnej
         siatki), raz zbijaly go w jednym miejscu. */
      const pasy = tasuj(ile, los);

      let x = brzeg;
      szerokosci.forEach((s, j) => {
        const dy = ((pasy[j] + los()) / ile) * luzY;
        /* Kolejnosc siegania do generatora jest czescia umowy: dy,
           potem okres, potem faza — tak samo jak przed rozdzieleniem,
           zeby te same frazy ukladaly sie identycznie jak dotad. */
        const okres = 7 + los() * 4;
        const faza = -los() * 8;
        pozycje.push({ left: x + s / 2 + dx[j], top: y + dy, szer: s, okres, faza });
        x += s + jedn;
      });

      y += najwyzszy + luzY + odstep;
      i += ile;
    });

    return { pozycje, wysokosc: Math.round(y) };
  };

  /* Naklada policzone wspolrzedne na ISTNIEJACE elementy. Dziala tak
     samo na kafle sklonowane ze wzorca i na te, ktore przyszly z
     serwera — dzieki temu /search dostanie ten sam uklad bez ani jednej
     dodatkowej linii algorytmu. */
  const zastosuj = (elementy, uklad) => {
    elementy.forEach((el, i) => {
      const p = uklad.pozycje[i];
      if (!p) return;
      el.classList.add(`ez-search__item--${rozmiar(i)}`);
      el.style.setProperty('--ez-x', `${p.left.toFixed(2)}%`);
      el.style.setProperty('--ez-y', `${Math.round(p.top)}px`);
      el.style.setProperty('--ez-w', `${p.szer.toFixed(2)}%`);
      el.style.setProperty('--ez-okres', `${p.okres.toFixed(2)}s`);
      el.style.setProperty('--ez-faza', `${p.faza.toFixed(2)}s`);
    });
  };

  /* Sciezka okna wyszukiwarki: zbuduj kafle z danych, policz uklad,
     nalóż. Wysokosc mapy musi byc jawna, bo dzieci sa pozycjonowane
     absolutnie i nie rozepna rodzica. */
  const zbudujMape = (produkty, fraza) => {
    const mapa = document.createElement('div');
    mapa.className = 'ez-search__map';
    const chmura = document.createElement('ul');
    chmura.className = 'ez-search__cloud list-unstyled';
    chmura.setAttribute('role', 'list');
    const elementy = produkty.map((p) => {
      const el = kafel(p);
      chmura.appendChild(el);
      return el;
    });
    mapa.appendChild(chmura);

    const uklad = policzUklad(produkty.length, fraza, grid.clientWidth || window.innerWidth);
    zastosuj(elementy, uklad);
    mapa.style.height = `${uklad.wysokosc}px`;
    return mapa;
  };

  /* Wyjscie do pelnych wynikow nie plywa i nie jest czescia mapy: to
     jedyny element nawigacyjny na tym ekranie, wiec musi byc
     przewidywalny. Stoi pod mapa, wysrodkowany. */
  const kafelWszystkie = (fraza) => {
    const a = document.createElement('a');
    a.className = 'ez-search__all';
    a.setAttribute('href', `/search?q=${encodeURIComponent(fraza)}`);
    const napis = document.createElement('span');
    napis.textContent = 'Zobacz wszystkie wyniki';
    const strzalka = document.createElement('span');
    strzalka.className = 'ez-arrow';
    strzalka.setAttribute('aria-hidden', 'true');
    strzalka.textContent = '\u2192';
    a.append(napis, strzalka);
    return a;
  };

  /* Cache trzyma DANE, nie gotowy markup. Powrot do frazy przelicza
     wiec uklad pod aktualna szerokosc kontenera; wczesniej wracal
     zapamietany napis zbudowany pod poprzedni breakpoint, wiec po
     obroceniu telefonu fraza z historii wracala w ukladzie desktopowym. */
  const zbuduj = (produkty, fraza) =>
    produkty.length === 0 ? [] : [zbudujMape(produkty, fraza), kafelWszystkie(fraza)];

  /* Ogloszenie odlozone i zawsze pojedyncze. */
  const oglos = (tekst) => {
    clearTimeout(timerOgloszenia);
    timerOgloszenia = setTimeout(() => {
      status.textContent = tekst;
    }, OGLOSZENIE_PO);
  };

  /* --- podmiana wynikow ---
     Wysokosc kontenera zamrazamy na czas podmiany. To jedyne, co
     powstrzymuje strone przed skakaniem, gdy liczba kafli sie zmienia. */
  const pokaz = (wezly, etykieta) => {
    const wysokosc = grid.offsetHeight;
    if (!reduced.matches && wysokosc > 0) {
      grid.style.minHeight = `${wysokosc}px`;
      grid.classList.add('is-swapping');
    }

    const zamien = () => {
      grid.replaceChildren(...wezly);
      if (label) label.textContent = etykieta;
      grid.classList.remove('is-swapping');
      requestAnimationFrame(() => {
        grid.style.minHeight = '';
      });
    };

    if (reduced.matches) zamien();
    else setTimeout(zamien, 120);
  };

  const przywrocPusty = () => {
    if (kontroler) kontroler.abort();
    pokaz([], etykietaPusta);
    oglos('');
  };

  const szukaj = async (fraza) => {
    if (cache.has(fraza)) {
      const p = cache.get(fraza);
      pokaz(zbuduj(p.produkty, fraza), p.etykieta);
      oglos(p.ogloszenie);
      return;
    }

    if (kontroler) kontroler.abort();
    kontroler = new AbortController();

    const url =
      `/search/suggest.json?q=${encodeURIComponent(fraza)}` +
      `&resources[type]=product&resources[limit]=${LIMIT}`;

    try {
      const odp = await fetch(url, { signal: kontroler.signal });
      const dane = await odp.json();
      const wszystkie = (dane.resources && dane.resources.results && dane.resources.results.products) || [];

      /* Egzemplarze Legit Check nie sa na sprzedaz i nie moga trafic do
         wynikow. suggest.json ich nie odsiewa — panel Savora robi to
         w Liquidzie, my musimy tutaj. */
      const produkty = wszystkie.filter((p) => !(p.tags || []).includes('hide-search'));

      let etykieta;
      let ogloszenie;

      if (produkty.length === 0) {
        etykieta = `Brak wyników dla „${fraza}”`;
        ogloszenie = `Brak wyników dla ${fraza}.`;
      } else {
        etykieta = `${produkty.length} ${produkty.length === 1 ? 'wynik' : 'wyników'} dla „${fraza}”`;
        ogloszenie = `Znaleziono ${produkty.length} produktów dla ${fraza}.`;
      }

      cache.set(fraza, { produkty, etykieta, ogloszenie });
      pokaz(zbuduj(produkty, fraza), etykieta);
      oglos(ogloszenie);
    } catch (e) {
      if (e.name === 'AbortError') return;
      pokaz([], etykietaPusta);
      oglos('Nie udało się pobrać wyników.');
    }
  };

  /* --- otwieranie i zamykanie --- */

  const otworz = (od) => {
    wyzwalacz = od || document.activeElement;
    panel.showModal();
    panel.classList.add('is-open');
    panel.dispatchEvent(new CustomEvent('ez:open'));
    ustawSzerokoscPola();
    ustawWysokosc();
    /* Fokus po pierwszej klatce, zeby czytnik ekranu zdazyl ogłosic
       otwarcie okna zanim przeskoczy do pola. */
    requestAnimationFrame(() => input.focus());
  };

  const zamknij = () => {
    panel.classList.remove('is-open', 'is-typing');
    if (kontroler) kontroler.abort();
    clearTimeout(timerSzukania);
    clearTimeout(timerOgloszenia);
    status.textContent = '';
    panel.close();
    /* Nie zdajemy sie na powrot fokusu z przegladarki — bywa rozny
       miedzy silnikami.

       Lupy w naglowku sa DWIE (wersja mobilna i desktopowa) i w danej
       szerokosci jedna z nich ma zerowe wymiary. Fokus na takim
       przycisku nie zadziala, wiec gdy zapamietany wyzwalacz zdazyl
       zniknac — na przyklad po obroceniu telefonu przy otwartym
       panelu — siegamy po ten, ktory jest widoczny. */
    const widoczny = (el) => el && document.contains(el) && el.getBoundingClientRect().width > 0;
    const cel = widoczny(wyzwalacz)
      ? wyzwalacz
      : Array.from(document.querySelectorAll(TRIGGER)).find(widoczny);
    if (cel) cel.focus();
  };

  /* Przejecie lupy Savora w fazie przechwytywania.

     Blokujemy nie tylko 'click'. Zgloszony zostal przypadek, w ktorym
     oba panele otwieraly sie naraz, a zadnego z czterech scenariuszy
     (klik w kazda z dwoch lup, fokus w polu, pisanie) nie udalo sie
     odtworzyc. Skoro nie znam drogi, ktora Savor tam wchodzi, zamykam
     wszystkie, ktore moge zamknac tanio: wskaznik, mysz i klawiature.

     Przy pointerdown/mousedown NIE wolamy preventDefault — to
     odebraloby przyciskowi fokus. Wystarczy zatrzymanie propagacji. */
  const przejmij = (e, zPreventDefault) => {
    const t = e.target.closest ? e.target.closest(TRIGGER) : null;
    if (!t) return null;
    if (zPreventDefault) e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    return t;
  };

  /* PRZEJECIE LUPY DZIALA W OBU TRYBACH — rozni sie tylko to, co robi
     po przechwyceniu. W oknie otwiera panel; na /search pole jest juz na
     ekranie, wiec lupa ma tylko postawic w nim kursor i zaznaczyc fraze.
     W ZADNYM z trybow nie wolno dopuscic panelu Savora.

     Wczesniej caly ten blok siedzial w warunku `if (!trybStrony)`, wiec
     na /search znikalo naraz przejecie lupy I straznik. Skutek: klik
     w lupe otwieral stary panel Savora nad naszymi wynikami. */
  const poLupie = (t) => {
    if (trybStrony) {
      input.focus();
      input.select();
      return;
    }
    otworz(t);
  };

  ['pointerdown', 'mousedown', 'touchstart'].forEach((typ) => {
    document.addEventListener(
      typ,
      (e) => {
        /* preventDefault na tej fazie NIE wchodzi w gre w zadnym trybie.
           Sprawdzone na zywo: odebranie domyslnej akcji na pointerdown
           tlumi tez zdarzenie `click`, wiec przechwycenie lupy przestaje
           dzialac — fokus zostawal na przycisku zamiast trafic w pole.
           Panel Savora i tak nie zdazy nic zrobic, bo klik zatrzymujemy
           w fazie przechwytywania, a blokade przewijania sprzata po nim
           odblokujPrzewijanie(). */
        przejmij(e, false);
      },
      true
    );
  });

  document.addEventListener('click', (e) => {
    const t = przejmij(e, true);
    if (t) poLupie(t);
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    const t = przejmij(e, true);
    if (t) poLupie(t);
  }, true);

  /* Straznik. Nie zgadujemy, czym Savor otwiera swoj panel — pilnujemy
     stanu. W trybie okna: dopoki nasze jest otwarte, jego byc nie moze.
     W trybie strony: nie moze byc NIGDY, bo cala jego tresc jest juz na
     stronie. MutationObserver lapie kazde otwarcie niezaleznie od tego,
     co je wywolalo. */
  /* Panele Savora nosza atrybut `scroll-lock`. Jego narzedzie przy
     otwarciu klada na <body> `position: fixed` z zapamietana pozycja,
     a przy zamknieciu zdejmuje. My zamykamy panel WYMUSZENIE, wolajac
     close() wprost — wtedy sciezka zdejmujaca blokade sie nie wykonuje
     i <body> zostaje przybity na stale.

     Na /search bylo to widac za kazdym razem, bo tam straznik zamyka
     panel bezwarunkowo. Gdzie indziej odpalal sie tylko wtedy, gdy panel
     naprawde zdazyl sie otworzyc — wyciek byl rzadki i umykal.

     Sprzatamy wiec sami. Ruszamy WYLACZNIE wlasciwosci blokady:
     w tym samym atrybucie `style` motyw trzyma swoje zmienne
     (--header-height i spolka), wiec czyszczenie calego stylu
     zniszczyloby uklad naglowka. */
  const odblokujPrzewijanie = () => {
    const b = document.body;
    if (b.style.position !== 'fixed') return;
    const y = Math.abs(parseInt(b.style.top, 10)) || 0;
    b.style.removeProperty('position');
    b.style.removeProperty('top');
    b.style.removeProperty('width');
    if (y) window.scrollTo(0, y);
  };

  const panelSavora = document.querySelector('dialog.search-modal__content');
  if (panelSavora) {
    const zamknijSavora = () => {
      if (panelSavora.open) panelSavora.close();
      /* Blokada bywa zakladana tuz PO otwarciu, wiec samo sprzatniecie
         teraz moze wyprzedzic jej powstanie. Drugie podejscie w nastepnej
         klatce lapie ten przypadek. */
      odblokujPrzewijanie();
      requestAnimationFrame(odblokujPrzewijanie);
    };
    new MutationObserver(() => {
      if (trybStrony || panel.open) zamknijSavora();
    }).observe(panelSavora, { attributes: true, attributeFilter: ['open'] });

    /* Gdy nasz panel wchodzi, jego panel schodzi — nawet gdyby zdazyl
       sie otworzyc ulamek sekundy wczesniej. */
    panel.addEventListener('ez:open', zamknijSavora);
  }

  /* Zamykanie ma sens tylko tam, gdzie jest co zamykac. */
  if (!trybStrony) {
    panel.querySelectorAll('[data-ez-search-close]').forEach((b) => b.addEventListener('click', zamknij));

    /* Escape obsluguje <dialog> sam, ale domyslnie tylko zamyka element —
       porzadki (przerwany fetch, wyczyszczony status, powrot fokusu)
       musimy zrobic po swojemu. */
    panel.addEventListener('cancel', (e) => {
      e.preventDefault();
      zamknij();
    });
  }

  /* Pusta fraza nie moze nigdzie nawigowac. Zrodla byly dwa, oba
     zmierzone na zywym DOM.

     1. NASZ formularz ma jedno pole tekstowe, wiec Enter wyzwala
        domyslne wyslanie (implicit submission) — przy pustym polu
        wychodzil skok na /search?q=.

     2. FORMULARZ SAVORA na stronie /search. Blok _search-input pina
        handler zapisem `on:keydown="/handleKeyDown"`, a to w component.js
        (linia 206) jest `document.addEventListener` bez trzeciego
        argumentu, czyli nasluch globalny w fazie babelkowania. Escape
        wcisniety w NASZYM oknie dochodzil do Savora, ten sprawdzal swoje
        wlasne, puste pole i robil `form.submit()` na formularzu
        z ukrytym `type=product`. Stad dokladnie ten adres ze zgloszenia:
        /search?type=product&q=.

     Przy niepustej frazie Enter dalej prowadzi do pelnych wynikow — to
     ten sam cel, co widoczne "Zobacz wszystkie wyniki", wiec zachowanie
     zostaje spojne z tym, co uzytkownik ma przed oczami.

     `stopPropagation` nie rusza akcji domyslnej, wiec <dialog> dostaje
     `cancel` jak dotad i Escape nadal zamyka nasze okno. */
  input.form?.addEventListener('submit', (e) => {
    if (!input.value.trim()) e.preventDefault();
  });

  panel.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') e.stopPropagation();
  });

  /* --- pisanie --- */

  /* Wejscie w pole zaznacza to, co juz w nim jest, wiec pisanie
     ZASTEPUJE fraze zamiast ja przedluzac. Bez tego kursor ladowal
     w srodku starego tekstu: wpisane "gap", klikniecie z powrotem
     i "balenciaga" dawalo "gapbalenciaga".

     Samo select() w focusie nie wystarcza. Po focusie przychodzi
     mouseup, ktory domyslnie stawia kursor w miejscu klikniecia
     i kasuje zaznaczenie — w przegladarce widac wtedy mrugniecie
     i efekt zerowy. Blokujemy wiec TEN JEDEN mouseup, ale tylko gdy
     wskaznik nie drgnal: przeciagniecie ma dalej zaznaczac fragment
     frazy, bo inaczej odebralibysmy mozliwosc poprawienia literowki.
     Fokus z klawiatury (Tab) nie ma zadnego mouseup i dziala sam. */
  let fokusZKlikniecia = false;
  let mysz = { x: 0, y: 0 };

  input.addEventListener('mousedown', (e) => {
    fokusZKlikniecia = document.activeElement !== input;
    mysz = { x: e.clientX, y: e.clientY };
  });

  input.addEventListener('focus', () => input.select());

  input.addEventListener('mouseup', (e) => {
    if (!fokusZKlikniecia) return;
    fokusZKlikniecia = false;
    if (Math.abs(e.clientX - mysz.x) + Math.abs(e.clientY - mysz.y) > 3) return;
    e.preventDefault();
  });

  input.addEventListener('input', () => {
    const fraza = input.value.trim();
    panel.classList.toggle('is-typing', fraza.length > 0);
    clearTimeout(timerSzukania);

    if (fraza.length < MIN_ZNAKOW) {
      przywrocPusty();
      return;
    }
    timerSzukania = setTimeout(() => szukaj(fraza), DEBOUNCE);
  });

  /* --- telefon i pozycja terminala ---
     100dvh nie wystarcza: klawiatura ekranowa zaslania dol panelu,
     a dvh o tym nie wie. visualViewport wie.

     Przy okazji liczymy, o ile zsunac scene w dol, zeby terminal
     wypadl dokladnie na srodku ekranu w stanie pustym. Robi to JS,
     bo wartosc zalezy od wysokosci okna i od samego terminala —
     w CSS nie ma jak tego wyrazic. Przy pisaniu klasa is-typing
     zeruje transform i scena wraca na gore. */
  /* Pole jest w pigulce o szerokosci dopasowanej do tresci, wiec musi
     samo znac swoja szerokosc. Mierzymy realny tekst placeholdera tym
     samym krojem i trackingiem — sztywna wartosc w ch obcinala go
     w polowie wyrazu przy dluzszym napisie z edytora. */
  function ustawSzerokoscPola() {
    const cs = getComputedStyle(input);
    const probka = document.createElement('span');
    probka.style.cssText =
      'position:absolute;visibility:hidden;white-space:nowrap;' +
      `font-family:${cs.fontFamily};font-size:${cs.fontSize};` +
      `letter-spacing:${cs.letterSpacing};text-transform:${cs.textTransform}`;
    probka.textContent = input.placeholder || '';
    document.body.appendChild(probka);
    const szer = Math.ceil(probka.getBoundingClientRect().width);
    probka.remove();
    if (szer > 0) panel.style.setProperty('--ez-input-w', `${szer + 4}px`);
  }

  function ustawWysokosc() {
    const vv = window.visualViewport;
    const h = vv ? vv.height : window.innerHeight;
    panel.style.setProperty('--ez-search-h', `${h}px`);

    /* Okno musi jechac za viewportem WIDOCZNYM, nie za ukladem.
       <dialog> otwarty przez showModal() dostaje position: fixed, czyli
       jest przypiety do viewportu UKLADU — a tego klawiatura nie zmienia
       (zmierzone: przewiniecie dokumentu o 300px nie rusza dialogu).
       Klawiatura zmienia tylko viewport widoczny, i iOS dodatkowo
       przesuwa go w dol, zeby odslonic pole nad klawiatura. To
       przesuniecie siedzi w offsetTop.

       Bez tej korekty okno zostawalo na gorze ukladu i uciekalo poza
       ekran: zmierzone dla przesuniecia 120px zostawaly 2 z 58px
       pigulki, a na dole widac bylo pasek strony spod dialogu.

       Sam offsetTop nie generuje `resize` — leci jako `scroll` na
       visualViewport, dlatego dotychczasowy nasluch tego nie lapal. */
    panel.style.setProperty('--ez-search-y', `${vv ? Math.round(vv.offsetTop) : 0}px`);

    const terminal = panel.querySelector('[data-ez-search-terminal]');
    if (!terminal) return;
    /* Cel: srodek terminala ma wypasc na srodku EKRANU, a nie na srodku
       przestrzeni pod gornym odstepem. Terminal startuje na wysokosci
       tego odstepu (miejsce na przycisk zamkniecia), wiec trzeba go
       odjac od docelowej pozycji. Bez tego terminal siadal 32px za
       nisko — zmierzone na 1280x720. */
    const gora = parseFloat(getComputedStyle(panel).getPropertyValue('--ez-search-top')) || 0;
    const docelowy = (h - terminal.offsetHeight) / 2;
    panel.style.setProperty('--ez-term-y', `${Math.max(0, Math.round(docelowy - gora))}px`);
  }

  if (!trybStrony && window.visualViewport) {
    /* `resize` niesie zmiane wysokosci (klawiatura wchodzi i schodzi),
       `scroll` niesie zmiane offsetTop (iOS odslania pole nad
       klawiatura). Do tej pory bylo tylko `resize`, wiec korekta
       wysokosci dzialala, a przesuniecie zostawalo nieobsluzone. */
    ['resize', 'scroll'].forEach((typ) => {
      window.visualViewport.addEventListener(typ, () => {
        if (panel.open) ustawWysokosc();
      });
    });
  }
  if (!trybStrony) {
    window.addEventListener('resize', () => {
      if (panel.open) ustawWysokosc();
    });
  }

  /* Zsuniecie w dol zamyka panel — ale tylko gdy lista jest na samej
     gorze, inaczej gest kolidowalby ze zwyklym przewijaniem wynikow. */
  let startY = null;
  if (!trybStrony) {
  panel.addEventListener(
    'touchstart',
    (e) => {
      startY = scroller && scroller.scrollTop > 0 ? null : e.touches[0].clientY;
    },
    { passive: true }
  );
  panel.addEventListener(
    'touchmove',
    (e) => {
      if (startY === null) return;
      if (e.touches[0].clientY - startY > 90) {
        startY = null;
        zamknij();
      }
    },
    { passive: true }
  );
  }

  /* --- tryb strony ---
     Kafle przychodza gotowe z serwera, wiec nie ma czego budowac —
     trzeba je tylko rozmiescic. Uklad liczy ta sama funkcja co w oknie
     i z tego samego ziarna (hash frazy), wiec ta sama fraza uklada sie
     na stronie tak samo jak w oknie. */
  const rozmiescZSerwera = () => {
    const mapa = grid.querySelector('.ez-search__map');
    if (!mapa) return;
    const elementy = Array.from(mapa.querySelectorAll('.ez-search__item'));
    if (elementy.length === 0) return;
    const uklad = policzUklad(elementy.length, input.value.trim(), grid.clientWidth || window.innerWidth);
    zastosuj(elementy, uklad);
    mapa.style.height = `${uklad.wysokosc}px`;
  };

  if (trybStrony) {
    /* Klasy is-open i is-typing nadaje juz Liquid — na stronie nie ma
       przejscia z pustego ekranu, wiec panel od razu jest w stanie
       roboczym. */
    ustawSzerokoscPola();
    rozmiescZSerwera();
    /* Szerokosc kadru decyduje o rozmiarach i wysokosci mapy, wiec przy
       zmianie okna uklad trzeba przeliczyc. Odlozone, bo resize potrafi
       leciec dziesiatki razy na sekunde. */
    let timerUkladu = 0;
    window.addEventListener('resize', () => {
      clearTimeout(timerUkladu);
      timerUkladu = setTimeout(rozmiescZSerwera, 150);
    });
  }
})();
